import React, { useEffect, useState } from 'react';
import { SuccessButton } from 'components/button';
import styled from 'styled-components';
import { COLOR } from 'constants/colors';
import { useMediaQuery } from 'react-responsive';
import { CommonStyledComponentProps } from '__utils/type';
import { Row, Col } from 'antd';
import { ENDPOINTS } from 'constants/endpoints';
import { get, getDefaultHeaders } from '__utils/ajax-wrapper';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';

const OuterContainer = styled.div<CommonStyledComponentProps>`
    .total-invest {
        display: flex;
        justify-content: space-between;
        margin: 16px;
    }
    .order-summary {
        padding: ${(props) => props.isMobile ? '16px' : '20px 20px 0'};
        background: white;
        fill: ${COLOR.WHITE};
        filter: drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.25));
        margin-bottom: ${(props) => props.isMobile ? '16px' : '40px'};
        border-radius: 8px;
    }
    .disclaimer {
        font-size: 12px;
        margin: 20px 0;
        padding: 9px 10px;
        background: #FDEFCE;
        border-left: 6px solid ${COLOR.WARNING_DARK};
    }
    .title-sec, .desc-sec {
        display: flex;
        justify-content: space-between;
    }
    .title-sec{
        color: ${COLOR.GREY3};
        line-height: normal;
        padding-bottom: 16px;
    }
    .desc-sec {
        padding-top: 16px;
        margin-bottom: 20px;
    }
    .desc-sec h3 {
        font-size: ${(props) => props.isMobile ? '14px' : ''};
        font-weight: 500;
        line-height: normal;
    }
    .title-sec + .desc-sec, .desc-sec + .desc-sec {
        border-top: 1px solid ${COLOR.DISABLED_BTN};
    }
    .desc-sec .investment-amount {
        font-weight: 600;
        padding-left: 16px;
    }
    .trans-failed h3,.trans-failed p{
        color: ${COLOR.GREY3};
    }
    .investment-type {
        text-transform: uppercase;
    }
    .trans-failed .investment-amount{
        color: #A1A6A7;
    }
`
const DesktopBtn = styled(SuccessButton)`
    width: 200px ;
    margin: 30px 0;
    display: block;
    text-align: center;
    height: 40px;
    border-radius: 4px;

`;

interface pageType {
    pageType: string;
    onGetOrderSuccess: Function;
}

const PaymentDetails: React.FC<pageType> = ({pageType,onGetOrderSuccess}) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const getOrderNo = window.location.search.split((pageType == 'failure') ? '&orderNo=' : '?orderNo=')[1];
    const [orderList, setOrderList] = useState<any>();

    useEffect(() => {
        getOrderDetails();
    }, []);

    const getOrderDetails = () => {
        get(
            `${ENDPOINTS.GET_ORDER_LIST}?pxOrderNumber=${getOrderNo}`,
            getDefaultHeaders(),
            true
        ).subscribe((response: AjaxResponse | AjaxError) => {
            if(response?.response?.meta?.statusCode === 200) {
                setOrderList(response?.response);
                onGetOrderSuccess(response?.response);
            }
        }, (error: AjaxError) => {
            console.log(error);
        });
    }

    return (
        <div>
            <OuterContainer isMobile={isMobile}>
                <Row>
                    <Col xs={24}>
                        <div className='summary-sec'>
                            <div className='title-sec'>
                                <div className='fund-name'>Fund Name</div>
                                <div className='fund-amount'>Investment Amount</div>
                            </div>
                            {orderList && orderList?.data.map((order:any) => {
                                return(
                                    <div className={`desc-sec ${pageType == 'success' ? 'trans-success' : 'trans-failed'}`}>
                                        <div className=''>
                                            <h3>{order?.mutualFund?.schemeName}</h3>
                                            <p className='investment-type'>{order?.investmentType}</p>
                                        </div>
                                        <div className='investment-amount'>{order?.amount}</div>
                                    </div>
                                )
                            })}
                        </div>
                    </Col>
                </Row>
            </OuterContainer>
        </div>
        )};

export default PaymentDetails;